export default "__VITE_ASSET__BRmLFUds__"